module.exports = __webpack_public_path__ + "static/media/sandals.15ec5145.jpg";